import { useState } from "react";
import RecordsUserZal from "./records-user-zal";
import RecordsUserSotr from "./records-user-sotr";

const RecordsUser = ({ user, width, height, qty, vid, calendars }) => {
  const [isHovered, setIsHovered] = useState(false);
  const fontSize = width < 60 ? width / 4 : undefined;
  
  const textStyle = {
    ...(fontSize ? { fontSize: `${fontSize}px` } : {}),
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal'
  };

  const containerStyle = {
    overflow: 'hidden',
    height: '100%'
  };

  const handleMouseEnter = () => {
    if (vid === 0 || vid === 1) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  
  return<div 
    style={{width, height, position: 'relative'}} 
    className="records-user"
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
  >
    {/* <img src={vid ? "/images/door.svg" : "/images/user.svg"} alt="user" className="records-user-img"/> */}
    <div className="records-user-data" style={containerStyle}>
      <div className="records-user-name" style={textStyle}>{user.name}</div>
    </div>
    
    {/* Хинт для зала */}
    {vid === 1 && isHovered && <RecordsUserZal user={user} qty={qty} />}
    {/* Хинт для сотрудника */}
    {vid === 0 && isHovered && <RecordsUserSotr user={user} qty={qty} calendars={calendars} />}
  </div>
}

export default RecordsUser;